// extracted by mini-css-extract-plugin
export default {"icon-wrapper":"icon-wrapper--COXxw","iconWrapper":"icon-wrapper--COXxw","icon":"icon--qwElh","name":"name--P_P3w"};